import { Done, Message, RemoveRedEye } from "@material-ui/icons";
import React, { useRef } from "react";
import Dropdown from "../../../Main/Dropdown/Dropdown";
import "./ChapterHeader.scss";

type Props = {
    title: string;
    views: number;
    comments: number;
    chapters: string[];
    jump: (index: number) => void;
    toggle: (e: Element) => void;
};

const ChapterHeader: React.FC<Props> = (props) => {
    const commentRef = useRef<HTMLDivElement | null>(null);
    return (
        <div className="chapter-header">
            <div>
                <Dropdown
                    title={props.title}
                    buttonStyles={{ border: "none", margin: 0, padding: 0 }}
                >
                    {props.chapters.map((chapter, index) => (
                        <label
                            key={index}
                            className={
                                props.title === chapter
                                    ? "check__container selected"
                                    : "check__container"
                            }
                            onClick={() => props.jump(index)}
                        >
                            <div>{chapter}</div>
                            {props.title === chapter && (
                                <Done className="green_dot" />
                            )}
                        </label>
                    ))}
                </Dropdown>
                <div className="views-comments">
                    <RemoveRedEye />
                    <span>{props.views}</span>
                    <Message />
                    <span>{props.comments}</span>
                </div>
            </div>
            <div ref={commentRef} style={{ position: "relative" }}>
                <button
                    className="comment-button"
                    onClick={() => {
                        props.toggle(commentRef.current as Element);
                    }}
                >
                    View Your Comments
                </button>
            </div>
        </div>
    );
};

export default ChapterHeader;
